import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchJastipFeeConfig, saveJastipFeeConfig } from './api'

export const jastipFeeKeys = {
  all: ['jastip-fee'] as const,
  config: () => [...jastipFeeKeys.all, 'config'] as const,
}

/** GET /v1/algo-pos-be/liotitip/configuration — global Jastip Fee config. */
export function jastipFeeConfigQueryOptions() {
  return queryOptions({
    queryKey: jastipFeeKeys.config(),
    queryFn: ({ signal }) => fetchJastipFeeConfig(signal),
    staleTime: 5 * 60_000,
  })
}

export function useSaveJastipFeeConfig() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveJastipFeeConfig,
    onSuccess: (config) => queryClient.setQueryData(jastipFeeKeys.config(), config),
  })
}
